import { IBenefit, IFullPlanDetail } from "../../../interfaces/api";

const HMODataTableDetailOverview = ({
  data,
  ppo,
}: {
  data: IFullPlanDetail;
  ppo?: boolean;
}) => {
  const ComparisonTableMobile = (data: IFullPlanDetail) => {
    let deductibleBenefit: IBenefit[] = [];

    data.PlanDetails[0].company[0].healthPlan[0].pbp[0].group.forEach(
      (group) => {
        if (group.pbpBenefitGroup === ("Premiums and Benefits" as string)) {
          group.category.forEach((category) => {
            if (category.pbpBenefitCategory === ("Deductible" as string)) {
              deductibleBenefit = category.benefit;
            }
          });
        }
      }
    );

    return deductibleBenefit;
  };
  const getPartB = (data: IFullPlanDetail) => {
    let partB: IBenefit[] = [];

    data.PlanDetails[0].company[0].healthPlan[0].pbp[0].group.forEach(
      (group) => {
        if (group.pbpBenefitGroup === ("Premiums and Benefits" as string)) {
          group.category.forEach((category) => {
            if (
              category.pbpBenefitCategory === ("Part B Reduction" as string)
            ) {
              partB = category.benefit;
            }
          });
        }
      }
    );

    return partB;
  };

  const getMonthlyPlan = (data: IFullPlanDetail) => {
    let partB: IBenefit[] = [];

    data.PlanDetails[0].company[0].healthPlan[0].pbp[0].group.forEach(
      (group) => {
        if (group.pbpBenefitGroup === ("Premiums and Benefits" as string)) {
          group.category.forEach((category) => {
            if (
              category.pbpBenefitCategory === ("Monthly Plan Premium" as string)
            ) {
              partB = category.benefit;
            }
          });
        }
      }
    );

    return partB;
  };

  const deductibleBenefit = ComparisonTableMobile(data);
  const partBBenefit = getPartB(data);
  const monthly = getMonthlyPlan(data);

  return (
    <>
      <div
        className="grid-x hide-for-small-only"
        style={{
          backgroundColor: "white",
          border: "1px solid #D3E1F0",
          textAlign: "left",
        }}
      >
        <div
          className="grid-x"
          style={{
            width: "100%",
            padding: "32px 20px",
            borderBottom: "1px solid #D3E1F0",
          }}
        >
          <div
            className="cell small-4"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            Monthly Premium
          </div>
          <div className=" cell small-8" style={{ paddingLeft: 20 }}>
            {/* {data.PlanDetails[0].MonthlyPremiumAmount >= 0
              ? "$" + data.PlanDetails[0].MonthlyPremiumAmount.toFixed(2)
              : "-"} */}
            {monthly[0].pbpBenefitDesc ? (
              <span
                dangerouslySetInnerHTML={{
                  __html: monthly[0].pbpBenefitDesc.replace(
                    /\\*\\n/g,
                    "<br />"
                  ),
                }}
              ></span>
            ) : (
              "-"
            )}
          </div>
        </div>
        <div
          className="grid-x"
          style={{
            width: "100%",
            padding: "32px 20px",
            borderBottom: "1px solid #D3E1F0",
          }}
        >
          <div
            className="cell small-4"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            Deductible
          </div>
          <div className=" cell small-8" style={{ paddingLeft: 20 }}>
            {deductibleBenefit ? deductibleBenefit[0]?.pbpBenefitDesc : "-"}
          </div>
        </div>
        <div
          className="grid-x"
          style={{
            width: "100%",
            padding: "32px 20px",
            borderBottom: "1px solid #D3E1F0",
          }}
        >
          <div
            className="cell small-4"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            Maximum Out-of-Pocket
          </div>
          <div className=" cell small-8" style={{ paddingLeft: 20 }}>
            {data.PlanDetails[0].MonthlyPremiumAmount >= 0
              ? data.PlanDetails[0].OutOfPocketMaxInNetworkAmount % 1 !== 0
                ? "$" +
                  data.PlanDetails[0].OutOfPocketMaxInNetworkAmount.toFixed(2)
                : "$" + data.PlanDetails[0].OutOfPocketMaxInNetworkAmount
              : "-"}
          </div>
        </div>
        <div
          className="grid-x"
          style={{
            width: "100%",
            padding: "32px 20px",
            borderBottom: "1px solid #D3E1F0",
          }}
        >
          <div
            className="cell small-4"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            Part B Rebate
          </div>
          <div className=" cell small-8" style={{ paddingLeft: 20 }}>
            {partBBenefit ? partBBenefit[0]?.pbpBenefitDesc : "-"}
          </div>
        </div>
      </div>
      <div
        className="grid-x show-for-small-only"
        style={{
          backgroundColor: "white",
          border: "1px solid #D3E1F0",
          textAlign: "left",
        }}
      >
        <div
          className="grid-x"
          style={{
            width: "100%",
            padding: "32px 10px",
            borderBottom: "1px solid #D3E1F0",
          }}
        >
          <div
            className="cell small-4"
            style={{ fontSize: "14px", fontWeight: 500 }}
          >
            Monthly Premium
          </div>
          <div
            className=" cell small-8"
            style={{ paddingLeft: 20, fontSize: 14 }}
          >
            {data.PlanDetails[0].MonthlyPremiumAmount >= 0
              ? "$" + data.PlanDetails[0].MonthlyPremiumAmount
              : "-"}
          </div>
        </div>
        <div
          className="grid-x"
          style={{
            width: "100%",
            padding: "32px 10px",
            borderBottom: "1px solid #D3E1F0",
          }}
        >
          <div
            className="cell small-4"
            style={{ fontSize: "14px", fontWeight: 500 }}
          >
            Deductible
          </div>
          <div
            className=" cell small-8"
            style={{ paddingLeft: 20, fontSize: 14 }}
          >
            {deductibleBenefit ? deductibleBenefit[0]?.pbpBenefitDesc : "-"}
          </div>
        </div>
        <div
          className="grid-x"
          style={{
            width: "100%",
            padding: "32px 20px",
            borderBottom: "1px solid #D3E1F0",
          }}
        >
          <div
            className="cell small-4"
            style={{ fontSize: "14px", fontWeight: 500 }}
          >
            Maximum Out-of-Pocket
          </div>
          <div
            className=" cell small-8"
            style={{ paddingLeft: 20, fontSize: 14 }}
          >
            {data.PlanDetails[0].MonthlyPremiumAmount >= 0
              ? "$" + data.PlanDetails[0].OutOfPocketMaxInNetworkAmount
              : "-"}
          </div>
        </div>
        <div
          className="grid-x"
          style={{
            width: "100%",
            padding: "32px 20px",
            borderBottom: "1px solid #D3E1F0",
          }}
        >
          <div
            className="cell small-4"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            Part B Rebate
          </div>
          <div className=" cell small-8" style={{ paddingLeft: 20 }}>
            {partBBenefit ? partBBenefit[0]?.pbpBenefitDesc : "-"}
          </div>
        </div>
      </div>
    </>
  );
};

export default HMODataTableDetailOverview;
